import React from "react";
import ReactGA from "react-ga";
import BotonContactar from "../components/layouts/boton/BotonContactar";
//imagenes
import Carrusel from "../components/layouts/carrusel/Carrusel";
import CarruselClient from "../components/layouts/carrusel/CarruselClient";
import HomeClientesBottom from "../components/layouts/HomeClientesBottom";
import ImageBootomHome from "../components/layouts/ImageBootomHome";
import SelectionHome from "../components/layouts/SelectionHome";

ReactGA.initialize(process.env.REACT_APP_ANALYTICS_ID);
ReactGA.pageview("/");

export default function Home() {
  return (
    <>
      <Carrusel />

      <SelectionHome />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          width: "80%",
        }}
      >
        <h1
          color="#161F6E"
          style={{
            color: "#161F6E",
          }}
        >
          Proyectos llave en mano
        </h1>
        <p
          color="#9197BC"
          style={{
            fontSize: "1.2em",
            fontWeight: "bolder",
            color: "#9197bc",
          }}
        >
          Desarrollamos proyectos de calderas y vapor <br />
          en su totalidad o en cualquiera de sus etapas, <br />
          proporcionando las últimas innovaciones <br />
          tecnológicas, constructivas, competitivas y <br />
          soluciones sustentables, sin perder de vista <br />
          la seguridad industrial.
        </p>
      </div>
      <ImageBootomHome />
      <BotonContactar />
      <CarruselClient />
    </>
  );
}
